const resources = {
    beautyMatchesPopupText: 'Une correspondance beauté est une personne qui possède les mêmes traits beauté que vous. Pour profiter pleinement de cette fonctionnalité, assurez-vous d’ajouter tous vos traits beauté dans votre',
    beautyMatchesPopupLink: 'Profil de la collectivité',
    beautyMatchesPopupTextUpdated: 'Une correspondance beauté est une personne qui partage les mêmes caractéristiques beauté que vous (teint de la peau ou préoccupations en matière de cheveux, etc.). Pour une expérience optimale avec cette fonction, veuillez ajouter vos renseignements à vos',
    beautyMatchesPopupLinkUpdated: 'Préférences beauté'
};

module.exports = function getResource(label) {
    return resources[label];
};
